import { ACTION, ACTION_SUBJECT, EVENT_TYPE, fireAnalyticsEvent } from '@atlaskit/editor-common/analytics';
import { EditorExperience } from '@atlaskit/editor-common/ufo';
import { getTTISeverity } from '@atlaskit/editor-common/utils';
export default function editorMeasureTTICallback(tti, ttiFromInvocation, canceled, distortedDuration, performanceTracking, featureFlags, createAnalyticsEvent, experienceStore) {
  var _performanceTracking$;
  if (performanceTracking !== null && performanceTracking !== void 0 && (_performanceTracking$ = performanceTracking.ttiTracking) !== null && _performanceTracking$ !== void 0 && _performanceTracking$.enabled && createAnalyticsEvent) {
    var _ttiTracking;
    var ttiEvent = {
      payload: {
        action: ACTION.EDITOR_TTI,
        actionSubject: ACTION_SUBJECT.EDITOR,
        attributes: {
          tti: tti,
          ttiFromInvocation: ttiFromInvocation,
          canceled: canceled,
          distortedDuration: distortedDuration
        },
        eventType: EVENT_TYPE.OPERATIONAL
      }
    };
    if ((_ttiTracking = performanceTracking.ttiTracking) !== null && _ttiTracking !== void 0 && _ttiTracking.trackSeverity) {
      var _ttiTracking2 = performanceTracking.ttiTracking,
        ttiSeverityNormalThreshold = _ttiTracking2.ttiSeverityNormalThreshold,
        ttiSeverityDegradedThreshold = _ttiTracking2.ttiSeverityDegradedThreshold,
        ttiFromInvocationSeverityNormalThreshold = _ttiTracking2.ttiFromInvocationSeverityNormalThreshold,
        ttiFromInvocationSeverityDegradedThreshold = _ttiTracking2.ttiFromInvocationSeverityDegradedThreshold;
      var _getTTISeverity = getTTISeverity(tti, ttiFromInvocation, ttiSeverityNormalThreshold, ttiSeverityDegradedThreshold, ttiFromInvocationSeverityNormalThreshold, ttiFromInvocationSeverityDegradedThreshold),
        ttiSeverity = _getTTISeverity.ttiSeverity,
        ttiFromInvocationSeverity = _getTTISeverity.ttiFromInvocationSeverity;
      ttiEvent.payload.attributes.ttiSeverity = ttiSeverity;
      ttiEvent.payload.attributes.ttiFromInvocationSeverity = ttiFromInvocationSeverity;
    }
    fireAnalyticsEvent(createAnalyticsEvent)(ttiEvent);
  }
  if (featureFlags !== null && featureFlags !== void 0 && featureFlags.ufo) {
    experienceStore === null || experienceStore === void 0 || experienceStore.mark(EditorExperience.loadEditor, ACTION.EDITOR_TTI, tti);
    experienceStore === null || experienceStore === void 0 || experienceStore.success(EditorExperience.loadEditor);
  }
}